var moduleMap = {
	"./AppPadSales": () => {
		return Promise.all([__webpack_require__.e(858), __webpack_require__.e(2432), __webpack_require__.e(2584), __webpack_require__.e(6740), __webpack_require__.e(8448), __webpack_require__.e(7963), __webpack_require__.e(3285), __webpack_require__.e(5948), __webpack_require__.e(3664), __webpack_require__.e(136), __webpack_require__.e(9505), __webpack_require__.e(3855), __webpack_require__.e(1321), __webpack_require__.e(4805)]).then(() => (() => ((__webpack_require__(4805)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});